import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=15f43d85"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports